<template>
  <v-container class="fill-height justify-center">
    <div class="d-flex justify-center align-center">
      <v-card elevation="0">
        <v-card-text>
          
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { TokenService } from "@/service/Storage.Service";
export default {
  data() {
    return {};
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    token() {
      return this.$store.state.token;
    },
  },

  methods: {
    logout() {
      TokenService.removeToken();
      window.location = "/login";
    },
  },
};
</script>

<style>
</style>